import React from "react";
import { Button, Result, ResultProps } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header/Header";
import { IS_MOBILE } from "@/utils/tool";
import Footer from "../Footer";
import "./index.scss";
import { clsx } from "clsx";

const ResultPage: React.FC = () => {
  const location = useLocation();
  let { status, title } = location?.state as ResultProps;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const registrationInfoRaw = location.search.slice(1).split("=")[1];
  const registrationInfo = JSON.parse(
    decodeURIComponent(`${registrationInfoRaw}`)
  );

  return (
    <section
      className={clsx(
        "result-page-wrapper",
        IS_MOBILE && "mobile-result-page-wrapper"
      )}
    >
      <Header></Header>
      <div className="content">
        <Result
          status={status}
          title={t(`${title}`)}
          subTitle={
            <>
              <div>
                <span>{t("期刊名称")}：</span>
                {registrationInfo.journalNames}
              </div>
              <div>
                <span>{t("文章标题")}：</span>
                {registrationInfo.articleTitle}
              </div>
            </>
          }
          extra={
            <Button onClick={() => navigate("/personal/registration")}>
              {t("查看详情")}
            </Button>
          }
        />
      </div>
      {!IS_MOBILE && <Footer></Footer>}
    </section>
  );
};

export default ResultPage;
